import React from 'react';
import { getConfig } from '../../../../utils/config';

function BlogCategory({ categories }) {
    const config = getConfig();
    return (
        <div
            className={`
        absolute right-0 font-medium 3xl:text-base px-4 py-1 m-3 rounded-full uppercase bg-primary text-white text-[12px] z-10 ${config?.blogs.layout5.categoryClass}  ${config?.blogs.fontBody}`}
        >
            <p>
                {categories?.map((obj) => {
                    return ' ' + `${obj.name}` + '  ';
                })}
            </p>
        </div>
    );
}

export default BlogCategory;
